import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { ModuleData, ProductData } from "../handlers";
import { isFlasherValid } from "../helpers";
import IVGraph from "./IVGraph";

interface FlasherDataProps {
  moduleData: ModuleData;
  productData: ProductData;
  isModuleValid: (isValid: boolean) => void;
}

const colors = {
  valid: {
    background: "#e8f5e9",
    graph: "#4caf50",
  },
  invalid: {
    background: "#fffde7",
    graph: "#ffc107",
  },
};

const FlasherData: React.FC<FlasherDataProps> = ({
  moduleData,
  productData,
  isModuleValid,
}) => {
  const isValid = isFlasherValid(moduleData, productData, isModuleValid);
  const theme = isValid ? colors.valid : colors.invalid;

  return (
    <Stack spacing={3}>
      <Stack
        direction="row"
        spacing={4}
        sx={{
          backgroundColor: theme.background,
          p: 2,
          borderRadius: 1.5,
          border: `1px solid ${theme.graph}`,
        }}
      >
        <Typography>
          <strong>Power:</strong> {moduleData.maxPower?.toFixed(2)} W
        </Typography>
        <Typography>
          <strong>Voc:</strong> {moduleData.maxVoltage?.toFixed(2)} V
        </Typography>
        <Typography>
          <strong>Isc:</strong> {moduleData.maxCurrent?.toFixed(2)} A
        </Typography>
      </Stack>

      {/* {moduleData.ivCurve && (
        <Box sx={{ position: "relative", height: "400px", width: "100%" }}>
          <IVGraph
            ivData={moduleData.ivCurve}
            plotTitle={`IV Curve (${moduleData.ivCurve.length.toLocaleString()} points)`}
            lineColor={theme.graph}
          />
        </Box>
      )} */}
    </Stack>
  );
};

export default FlasherData;
